/* SALES OP WEEKLY REPORT (2026-10-24). Codes (SAP, 3PL, EUSU, EXF, AR, HINC, USD) and the category names stay as they are. */
const en = {
  chExf: "EXF Status (USD)",
  chAr: "Account Receivables",
  chResQty: "Reserved Stock Quantity (pcs)",
  chResAmt: "Reserved Stock Amount (USD)",
  chUncQty: "Uncommitted Stock Quantity (pcs)",
  chUncAmt: "Uncommitted Stock Amount (USD)",
  excelReportHint2: "The Excel report — it refreshes itself from 01_Output when opened in Excel (needs the Z: drive).",
  upButton: "Upload edited file",
  upButtonHint: "Download 00_Config.xlsx, edit it in Excel, then upload it here — you see what changes before anything is saved.",
  upTitle: "Uploaded: {{file}}",
  upHint: "Compared with the current file by Item Code / Buyer / Stock Location ID. Nothing is saved until you press Apply; the current file is kept as a backup.",
  upCounts: "{{c}} changed · {{a}} added · {{m}} not in your file",
  upChanged: "Changed",
  upAdded: "New",
  upNotInFile: "Not in your file — kept",
  upRemoved: "Will be removed",
  upRemoveMissing: "Also remove the {{n}} row(s) that are not in my file (leave this off if your copy was downloaded before the last run)",
  upApply: "Apply {{n}} change(s)",
  upApplying: "Applying…",
  upNothing: "Your file is the same as the current one — nothing to change.",
  upProblems: "{{n}} problem(s) in the file — fix them in Excel and upload again. Nothing was saved.",
  upMore: "…and {{n}} more.",
  upDone: "Saved from your file — {{what}}. The file before is kept as {{backup}}.",
  tabConfig: "Config",
  cfgFile: "00_Config.xlsx · saved {{when}}",
  cfgHint: "The lookups the job reads on every run. Change them here when something new appears — a new item code, a new buyer, a new stock location — and the next run uses them.",
  cfg_item: "Items",
  cfg_customer: "Customers",
  cfg_location: "Stock locations",
  cfgUse_item: "03_PD-Category-Price — 3PL and EUSU price their stock by Item Code. A code with no category or price stops the run.",
  cfgUse_customer: "01_Customer — AR puts each buyer under its Helinox entity (matched ignoring capitals and spaces); a buyer not listed goes to Others.",
  cfgUse_location: "02_Stock-Location — SAP Stock Status names each location by its ID.",
  cfgSearch: "Search this sheet",
  cfgNeed: "No category or price ({{n}})",
  cfgClear: "Clear filters",
  cfgCount: "{{n}} of {{total}} rows",
  cfgEdit: "Edit the table",
  cfgAdd: "Add a line",
  cfgCancel: "Cancel",
  cfgSave: "Save ({{n}})",
  cfgSaveFirst: "Save or cancel the changes on this sheet first.",
  cfgRunning: "The job is running — edit when it has finished.",
  cfgViewOnly: "You can read this sheet; changing it needs edit access to Sales Op. Python.",
  cfgRow: "Row",
  cfgRowHint: "The row in the Excel sheet",
  cfgNew: "New",
  cfgRemove: "Remove this row",
  cfgKeep: "Keep this row",
  cfgWas: "Was: {{v}}",
  cfgMissing: "missing",
  cfgDup: "twice",
  cfgDupHint: "This code is on more than one row (the job adds a code it cannot match as a second row). Remove the extra row.",
  cfgNone: "No row matches.",
  cfgSaved: "{{sheet}}: {{n}} change(s) saved. The file before them is kept as {{backup}}.",
  title: "Sales Op Weekly Report",
  week: "Week",
  thisWeekTag: "this week",
  sandbox: "Staging · sandbox folder",
  sandboxHint: "On staging the job runs on a copy of the folder, never the team's real Z:\\AutoJobs files.",
  refresh: "Refresh",
  loading: "Loading…",
  tabFiles: "Files",
  tabRun: "Run",
  tabReport: "Report",
  notRun: "not run",
  running: "Running…",
  dropTitle: "Drop the {{week}} files here",
  dropHint: "All of them at once — each goes to its row by its name and is saved under the name the job reads.",
  chooseFiles: "Choose files",
  uploading: "Uploading…",
  savedAs: "Saved as {{file}}.",
  dismiss: "Dismiss",
  filesCount: "{{n}} of {{total}} files in {{week}}",
  colFile: "File",
  colStatus: "Status",
  colSaved: "Saved as",
  colSize: "Size",
  colUploaded: "Uploaded",
  colAction: "Action",
  group_sap: "SAP inventory",
  group_eusu: "EUSU inventory",
  group_exf: "Pending order and shipment status (EXF)",
  group_ar: "Account receivable",
  missing: "Missing",
  ready: "Ready",
  otherWeek: "Named {{tag}}",
  tagHint: "The job reads this week's file or last week's (as a carry-over). Any other week is skipped.",
  twoFiles: "{{n}} files",
  twoHint: "More than one file matches this row; the job may read the wrong one. Remove the extra.",
  originalName: "uploaded as {{name}}",
  fromFolder: "from the folder",
  fromFolderHint: "Put in the folder directly (Z: drive), not through this screen.",
  upload: "Upload",
  replace: "Replace",
  remove: "Remove",
  removeAsk: "Remove {{name}} from the week folder? It is kept in _portal_replaced.",
  extrasTitle: "Other files in the folder",
  extrasHint: "Not one of the 16 the job expects. Remove anything that does not belong — an extra SAP-Inventory file is read by the job.",
  allFiles: "All {{n}} files are in",
  someMissing: "{{n}} of {{total}} files missing — the steps that need them will fail",
  onlyCurrent: "Runs only for {{week}}",
  onlyCurrentHint: "The job works out its week from today's date, so it can only run for the current week. Reports of earlier weeks are on the Report tab.",
  runJob: "Run the job for {{week}}",
  runMissingAsk: "{{n}} file(s) are missing. Run anyway?",
  runningBy: "Started by {{by}} at {{when}}.",
  result_ok: "All steps ran",
  result_partial: "Some steps failed",
  result_error: "The job failed",
  result_running: "Running",
  runOf: "Run #{{n}} · {{week}} · {{by}} · {{when}}",
  took: "{{s}} s",
  step_sap: "SAP inventory",
  step_tpl: "3PL inventory",
  step_eusu: "EUSU inventory",
  step_exf: "EXF status",
  step_ar: "Account receivable",
  stepOk: "Done",
  stepNotRun: "Not run",
  warnings: "{{n}} warning(s) from the job",
  goReport: "The output is updated — open step 3 for the report.",
  liveLog: "Job log (live)",
  fullLog: "Job log",
  starting: "Starting…",
  history: "Runs",
  noRuns: "No run from this screen yet.",
  colWeek: "Week",
  colStarted: "Started",
  colBy: "By",
  colResult: "Result",
  colSteps: "Steps",
  askedCodes: "asked for item codes",
  viewLog: "View",
  codesTitle: "The job needs {{n}} item code(s) in 00_Config.xlsx",
  codesHint: "New item codes have no category or purchase price yet. Fill them in here (saved straight into 00_Config.xlsx, sheet 03_PD-Category-Price), then run the job again.",
  codesNone: "Every item code in 00_Config.xlsx has a category and a price.",
  codesSave: "Save {{n}} item code(s)",
  codesSaved: "{{n}} item code(s) saved into 00_Config.xlsx. Run the job again.",
  colItem: "Item code",
  colProduct: "Product",
  colCategory: "Category",
  colPrice: "Purchase price (USD)",
  reportWeek: "Report week",
  vsWeek: "against {{week}}",
  outputAt: "output updated {{when}}",
  excelReportHint: "The Excel report — it still refreshes from the output in Excel.",
  chartsPpt: "Slides (PowerPoint)",
  chartsPptHint: "Allie's three slides (EXF, account receivables, stock) with this week's figures — made now from 01_Output, no Z: drive needed. Copy the charts and tables into the weekly deck; add the comments by hand.",
  noData: "No figures for this week.",
  weekEmpty: "The output holds nothing for {{week}} yet — run the job first.",
  lastWeek: "Last week",
  thisWeek: "This week",
  change: "Change",
  total: "Total",
  lab_id: "Stock location",
  lab_category: "Category",
  lab_entity: "Entity",
  m_reserved: "Reserved stock",
  m_uncommitted: "Uncommitted stock",
  m_reservedQty: "Reserved qty",
  m_uncommittedQty: "Uncommitted qty",
  m_reservedAmt: "Reserved amount",
  m_uncommittedAmt: "Uncommitted amount",
  m_inProduction: "In production",
  m_exFactory: "Ex factory",
  m_paid: "Paid",
  m_onTrack: "On track",
  m_overdue: "Overdue",
  sec_sap: "SAP Stock Status",
  sec_tpl: "3PL Stock Status",
  sec_eusu: "EUSU Stock Status",
  sec_exf: "EXF Status",
  sec_newOrder: "New Order Status",
  sec_ar: "Account Receivable Management",
  sec_stock: "Stock Status (3PL + EUSU)",
  noNewOrder: "The New Order job has not run for this week (last: {{week}}).",
  unit: "Unit",
  no_chair: "Chair",
  no_cot: "Cot",
  no_table: "Table",
  no_tent: "Tent",
  no_others: "Others",
  arOverdue: "Overdue payments ({{n}})",
  arAll: "All payment lines ({{n}})",
  arShowAll: "Show all lines",
  arShowOverdue: "Overdue only",
  arNone: "No overdue payment this week.",
  buyer: "Buyer",
  amount: "Amount",
  payDate: "Paid / planned date",
  trendTitle: "3PL + EUSU stock this year, by week (qty)",
};

const ko = {
  chExf: "EXF 현황 (USD)",
  chAr: "매출채권",
  chResQty: "예약 재고 수량 (pcs)",
  chResAmt: "예약 재고 금액 (USD)",
  chUncQty: "미할당 재고 수량 (pcs)",
  chUncAmt: "미할당 재고 금액 (USD)",
  excelReportHint2: "엑셀 보고서 — 엑셀에서 열면 01_Output 으로 자동 새로고침됩니다 (Z: 드라이브 필요).",
  upButton: "수정 파일 업로드",
  upButtonHint: "00_Config.xlsx를 내려받아 Excel에서 수정한 뒤 여기에 올리세요 — 저장 전에 바뀌는 내용을 먼저 보여 줍니다.",
  upTitle: "업로드: {{file}}",
  upHint: "Item Code / Buyer / Stock Location ID 기준으로 현재 파일과 비교했습니다. 적용을 누르기 전에는 저장되지 않으며, 현재 파일은 백업됩니다.",
  upCounts: "변경 {{c}} · 추가 {{a}} · 파일에 없음 {{m}}",
  upChanged: "변경",
  upAdded: "신규",
  upNotInFile: "파일에 없음 — 유지",
  upRemoved: "삭제 예정",
  upRemoveMissing: "내 파일에 없는 {{n}}개 행도 삭제 (마지막 실행 전에 내려받은 파일이면 체크하지 마세요)",
  upApply: "{{n}}건 적용",
  upApplying: "적용 중…",
  upNothing: "현재 파일과 같습니다 — 바꿀 내용이 없습니다.",
  upProblems: "파일에 문제 {{n}}건 — Excel에서 고친 뒤 다시 올려 주세요. 저장된 것은 없습니다.",
  upMore: "…외 {{n}}건.",
  upDone: "파일 내용을 저장했습니다 — {{what}}. 이전 파일은 {{backup}}로 보관됩니다.",
  tabConfig: "설정",
  cfgFile: "00_Config.xlsx · 저장 {{when}}",
  cfgHint: "작업이 실행될 때마다 읽는 기준 목록입니다. 새 품목 코드, 새 거래처, 새 재고 위치가 생기면 여기서 바꾸세요. 다음 실행부터 적용됩니다.",
  cfg_item: "품목",
  cfg_customer: "거래처",
  cfg_location: "재고 위치",
  cfgUse_item: "03_PD-Category-Price — 3PL과 EUSU는 품목 코드로 재고 금액을 계산합니다. 카테고리나 가격이 없는 코드가 있으면 실행이 멈춥니다.",
  cfgUse_customer: "01_Customer — AR은 거래처를 Helinox 법인에 배정합니다(대소문자·공백 무시). 목록에 없는 거래처는 Others로 갑니다.",
  cfgUse_location: "02_Stock-Location — SAP 재고 현황은 위치 ID로 이름을 붙입니다.",
  cfgSearch: "이 시트에서 검색",
  cfgNeed: "카테고리/가격 없음 ({{n}})",
  cfgClear: "필터 지우기",
  cfgCount: "{{total}}행 중 {{n}}행",
  cfgEdit: "표 편집",
  cfgAdd: "행 추가",
  cfgCancel: "취소",
  cfgSave: "저장 ({{n}})",
  cfgSaveFirst: "먼저 이 시트의 변경을 저장하거나 취소하세요.",
  cfgRunning: "작업 실행 중입니다. 끝난 뒤 편집하세요.",
  cfgViewOnly: "이 시트는 볼 수만 있습니다. 변경하려면 Sales Op. Python 편집 권한이 필요합니다.",
  cfgRow: "행",
  cfgRowHint: "Excel 시트의 행 번호",
  cfgNew: "새 행",
  cfgRemove: "이 행 삭제",
  cfgKeep: "이 행 유지",
  cfgWas: "이전: {{v}}",
  cfgMissing: "없음",
  cfgDup: "중복",
  cfgDupHint: "이 코드가 여러 행에 있습니다(작업이 맞추지 못한 코드를 두 번째 행으로 추가함). 남는 행을 삭제하세요.",
  cfgNone: "일치하는 행이 없습니다.",
  cfgSaved: "{{sheet}}: {{n}}건 저장했습니다. 이전 파일은 {{backup}}로 보관됩니다.",
  title: "Sales Op 주간 보고서",
  week: "주차",
  thisWeekTag: "이번 주",
  sandbox: "스테이징 · 샌드박스 폴더",
  sandboxHint: "스테이징에서는 폴더 사본으로 작업을 실행하며, 팀의 실제 Z:\\AutoJobs 파일은 건드리지 않습니다.",
  refresh: "새로고침",
  loading: "불러오는 중…",
  tabFiles: "파일",
  tabRun: "실행",
  tabReport: "보고서",
  notRun: "미실행",
  running: "실행 중…",
  dropTitle: "{{week}} 파일을 여기에 놓으세요",
  dropHint: "한 번에 모두 — 이름으로 각 행에 배정되고 작업이 읽는 이름으로 저장됩니다.",
  chooseFiles: "파일 선택",
  uploading: "업로드 중…",
  savedAs: "{{file}}(으)로 저장했습니다.",
  dismiss: "닫기",
  filesCount: "{{week}} 파일 {{total}}개 중 {{n}}개",
  colFile: "파일",
  colStatus: "상태",
  colSaved: "저장 이름",
  colSize: "크기",
  colUploaded: "업로드",
  colAction: "작업",
  group_sap: "SAP 재고",
  group_eusu: "EUSU 재고",
  group_exf: "미결 주문 및 선적 현황 (EXF)",
  group_ar: "매출채권",
  missing: "없음",
  ready: "준비됨",
  otherWeek: "{{tag}}로 표기",
  tagHint: "작업은 이번 주 파일 또는 지난주 파일(이월)을 읽습니다. 다른 주차는 건너뜁니다.",
  twoFiles: "파일 {{n}}개",
  twoHint: "이 행에 맞는 파일이 둘 이상입니다. 잘못된 파일을 읽을 수 있으니 하나를 삭제하세요.",
  originalName: "{{name}}(으)로 업로드",
  fromFolder: "폴더에서 직접",
  fromFolderHint: "이 화면이 아니라 폴더(Z: 드라이브)에 직접 넣은 파일입니다.",
  upload: "업로드",
  replace: "교체",
  remove: "삭제",
  removeAsk: "{{name}}을(를) 주차 폴더에서 삭제할까요? _portal_replaced에 보관됩니다.",
  extrasTitle: "폴더의 기타 파일",
  extrasHint: "작업이 기대하는 16개 파일이 아닙니다. 필요 없는 파일은 삭제하세요 — 여분의 SAP-Inventory 파일도 작업이 읽습니다.",
  allFiles: "{{n}}개 파일 모두 준비됨",
  someMissing: "{{total}}개 중 {{n}}개 파일 없음 — 해당 단계는 실패합니다",
  onlyCurrent: "{{week}}에만 실행 가능",
  onlyCurrentHint: "작업은 오늘 날짜로 주차를 정하므로 이번 주에만 실행할 수 있습니다. 이전 주차 보고서는 보고서 탭에 있습니다.",
  runJob: "{{week}} 작업 실행",
  runMissingAsk: "파일 {{n}}개가 없습니다. 그래도 실행할까요?",
  runningBy: "{{by}}님이 {{when}}에 시작했습니다.",
  result_ok: "모든 단계 완료",
  result_partial: "일부 단계 실패",
  result_error: "작업 실패",
  result_running: "실행 중",
  runOf: "실행 #{{n}} · {{week}} · {{by}} · {{when}}",
  took: "{{s}}초",
  step_sap: "SAP 재고",
  step_tpl: "3PL 재고",
  step_eusu: "EUSU 재고",
  step_exf: "EXF 현황",
  step_ar: "매출채권",
  stepOk: "완료",
  stepNotRun: "미실행",
  warnings: "작업 경고 {{n}}건",
  goReport: "결과가 갱신되었습니다 — 3단계에서 보고서를 확인하세요.",
  liveLog: "작업 로그 (실시간)",
  fullLog: "작업 로그",
  starting: "시작 중…",
  history: "실행 기록",
  noRuns: "아직 이 화면에서 실행한 기록이 없습니다.",
  colWeek: "주차",
  colStarted: "시작",
  colBy: "실행자",
  colResult: "결과",
  colSteps: "단계",
  askedCodes: "품목 코드 요청",
  viewLog: "보기",
  codesTitle: "작업에 00_Config.xlsx 품목 코드 {{n}}개가 필요합니다",
  codesHint: "새 품목 코드에 카테고리와 구매가가 없습니다. 여기에 입력하면 00_Config.xlsx(03_PD-Category-Price 시트)에 바로 저장되며, 그다음 작업을 다시 실행하세요.",
  codesNone: "00_Config.xlsx의 모든 품목 코드에 카테고리와 가격이 있습니다.",
  codesSave: "품목 코드 {{n}}개 저장",
  codesSaved: "품목 코드 {{n}}개를 00_Config.xlsx에 저장했습니다. 작업을 다시 실행하세요.",
  colItem: "품목 코드",
  colProduct: "제품",
  colCategory: "카테고리",
  colPrice: "구매가 (USD)",
  reportWeek: "보고 주차",
  vsWeek: "{{week}} 대비",
  outputAt: "결과 갱신 {{when}}",
  excelReportHint: "엑셀 보고서 — 엑셀에서 결과 파일로 새로고침합니다.",
  chartsPpt: "슬라이드 (PowerPoint)",
  chartsPptHint: "Allie 의 슬라이드 3장 (EXF, 매출채권, 재고) 에 이번 주 수치 — 01_Output 으로 지금 만듭니다 (Z: 드라이브 불필요). 차트와 표를 주간 보고서에 복사하고, 코멘트는 직접 추가하세요.",
  noData: "이번 주 수치가 없습니다.",
  weekEmpty: "결과 파일에 {{week}} 데이터가 아직 없습니다 — 먼저 작업을 실행하세요.",
  lastWeek: "지난주",
  thisWeek: "이번 주",
  change: "변동",
  total: "합계",
  lab_id: "재고 위치",
  lab_category: "카테고리",
  lab_entity: "법인",
  m_reserved: "예약 재고",
  m_uncommitted: "미할당 재고",
  m_reservedQty: "예약 수량",
  m_uncommittedQty: "미할당 수량",
  m_reservedAmt: "예약 금액",
  m_uncommittedAmt: "미할당 금액",
  m_inProduction: "생산 중",
  m_exFactory: "출고",
  m_paid: "입금 완료",
  m_onTrack: "정상",
  m_overdue: "연체",
  sec_sap: "SAP 재고 현황",
  sec_tpl: "3PL 재고 현황",
  sec_eusu: "EUSU 재고 현황",
  sec_exf: "EXF 현황",
  sec_newOrder: "신규 주문 현황",
  sec_ar: "매출채권 관리",
  sec_stock: "재고 현황 (3PL + EUSU)",
  noNewOrder: "이번 주에는 신규 주문 작업이 실행되지 않았습니다 (마지막: {{week}}).",
  unit: "단위",
  no_chair: "Chair",
  no_cot: "Cot",
  no_table: "Table",
  no_tent: "Tent",
  no_others: "Others",
  arOverdue: "연체 건 ({{n}})",
  arAll: "전체 입금 건 ({{n}})",
  arShowAll: "전체 보기",
  arShowOverdue: "연체만",
  arNone: "이번 주 연체 건이 없습니다.",
  buyer: "거래처",
  amount: "금액",
  payDate: "입금(예정)일",
  trendTitle: "올해 3PL + EUSU 재고, 주차별 (수량)",
};

const vi = {
  chExf: "Tình trạng EXF (USD)",
  chAr: "Công nợ phải thu",
  chResQty: "Số lượng tồn kho đã giữ (pcs)",
  chResAmt: "Giá trị tồn kho đã giữ (USD)",
  chUncQty: "Số lượng tồn kho chưa phân bổ (pcs)",
  chUncAmt: "Giá trị tồn kho chưa phân bổ (USD)",
  excelReportHint2: "Báo cáo Excel — mở bằng Excel sẽ tự refresh từ 01_Output (cần ổ Z:).",
  upButton: "Upload file đã sửa",
  upButtonHint: "Tải 00_Config.xlsx về, sửa trong Excel rồi upload lại ở đây — bạn sẽ thấy những gì thay đổi trước khi lưu.",
  upTitle: "Đã upload: {{file}}",
  upHint: "So với file hiện tại theo Item Code / Buyer / Stock Location ID. Chưa lưu gì cho tới khi bấm Apply; file hiện tại được sao lưu.",
  upCounts: "{{c}} đổi · {{a}} thêm · {{m}} không có trong file của bạn",
  upChanged: "Đổi",
  upAdded: "Mới",
  upNotInFile: "Không có trong file — giữ nguyên",
  upRemoved: "Sẽ xóa",
  upRemoveMissing: "Xóa luôn {{n}} dòng không có trong file của tôi (đừng tick nếu file được tải về trước lần chạy gần nhất)",
  upApply: "Apply {{n}} thay đổi",
  upApplying: "Đang lưu…",
  upNothing: "File của bạn giống file hiện tại — không có gì để đổi.",
  upProblems: "File có {{n}} lỗi — sửa trong Excel rồi upload lại. Chưa lưu gì.",
  upMore: "…và {{n}} lỗi khác.",
  upDone: "Đã lưu từ file của bạn — {{what}}. File trước đó được giữ là {{backup}}.",
  tabConfig: "Config",
  cfgFile: "00_Config.xlsx · lưu lúc {{when}}",
  cfgHint: "Các danh mục job đọc mỗi lần chạy. Có mã hàng mới, buyer mới hay kho mới thì sửa ở đây — lần chạy sau sẽ dùng ngay.",
  cfg_item: "Mã hàng",
  cfg_customer: "Khách hàng",
  cfg_location: "Kho",
  cfgUse_item: "03_PD-Category-Price — 3PL và EUSU tính tiền tồn kho theo Item Code. Mã nào thiếu category hoặc giá thì job dừng.",
  cfgUse_customer: "01_Customer — AR xếp mỗi buyer vào entity Helinox (so khớp không phân biệt hoa thường, khoảng trắng); buyer không có trong danh sách vào Others.",
  cfgUse_location: "02_Stock-Location — SAP Stock Status đặt tên kho theo ID.",
  cfgSearch: "Tìm trong sheet này",
  cfgNeed: "Thiếu category hoặc giá ({{n}})",
  cfgClear: "Bỏ lọc",
  cfgCount: "{{n}} / {{total}} dòng",
  cfgEdit: "Sửa bảng",
  cfgAdd: "Thêm dòng",
  cfgCancel: "Hủy",
  cfgSave: "Lưu ({{n}})",
  cfgSaveFirst: "Lưu hoặc hủy thay đổi của sheet này trước.",
  cfgRunning: "Job đang chạy — sửa sau khi chạy xong.",
  cfgViewOnly: "Bạn chỉ xem được sheet này; muốn sửa cần quyền edit Sales Op. Python.",
  cfgRow: "Dòng",
  cfgRowHint: "Số dòng trong sheet Excel",
  cfgNew: "Mới",
  cfgRemove: "Xóa dòng này",
  cfgKeep: "Giữ dòng này",
  cfgWas: "Trước: {{v}}",
  cfgMissing: "thiếu",
  cfgDup: "trùng",
  cfgDupHint: "Mã này nằm ở nhiều dòng (job thêm mã không khớp thành dòng thứ hai). Xóa dòng thừa.",
  cfgNone: "Không có dòng nào khớp.",
  cfgSaved: "{{sheet}}: đã lưu {{n}} thay đổi. File trước đó được giữ là {{backup}}.",
  title: "Báo cáo tuần Sales Op",
  week: "Tuần",
  thisWeekTag: "tuần này",
  sandbox: "Staging · thư mục bản sao",
  sandboxHint: "Trên staging job chạy trên bản sao của thư mục, không bao giờ đụng file thật của team ở Z:\\AutoJobs.",
  refresh: "Làm mới",
  loading: "Đang tải…",
  tabFiles: "File",
  tabRun: "Chạy",
  tabReport: "Báo cáo",
  notRun: "chưa chạy",
  running: "Đang chạy…",
  dropTitle: "Thả các file của {{week}} vào đây",
  dropHint: "Thả tất cả một lần — mỗi file tự vào đúng dòng theo tên và được lưu đúng tên mà job đọc.",
  chooseFiles: "Chọn file",
  uploading: "Đang tải lên…",
  savedAs: "Đã lưu thành {{file}}.",
  dismiss: "Đóng",
  filesCount: "{{n}}/{{total}} file trong {{week}}",
  colFile: "File",
  colStatus: "Trạng thái",
  colSaved: "Lưu thành",
  colSize: "Dung lượng",
  colUploaded: "Tải lên",
  colAction: "Thao tác",
  group_sap: "Tồn kho SAP",
  group_eusu: "Tồn kho EUSU",
  group_exf: "Tình trạng đơn hàng và giao hàng (EXF)",
  group_ar: "Công nợ phải thu",
  missing: "Thiếu",
  ready: "Sẵn sàng",
  otherWeek: "Tên ghi {{tag}}",
  tagHint: "Job đọc file của tuần này hoặc tuần trước (dùng tạm). Tuần khác sẽ bị bỏ qua.",
  twoFiles: "{{n}} file",
  twoHint: "Có nhiều hơn một file khớp dòng này; job có thể đọc nhầm. Hãy xóa file thừa.",
  originalName: "tải lên với tên {{name}}",
  fromFolder: "bỏ thẳng vào thư mục",
  fromFolderHint: "File được bỏ trực tiếp vào thư mục (ổ Z:), không qua màn hình này.",
  upload: "Tải lên",
  replace: "Thay",
  remove: "Xóa",
  removeAsk: "Xóa {{name}} khỏi thư mục tuần? File được giữ lại trong _portal_replaced.",
  extrasTitle: "File khác trong thư mục",
  extrasHint: "Không thuộc 16 file job cần. Hãy xóa file không liên quan — một file SAP-Inventory thừa vẫn bị job đọc.",
  allFiles: "Đủ {{n}} file",
  someMissing: "Thiếu {{n}}/{{total}} file — các bước cần file đó sẽ lỗi",
  onlyCurrent: "Chỉ chạy được cho {{week}}",
  onlyCurrentHint: "Job lấy tuần theo ngày hôm nay nên chỉ chạy được cho tuần hiện tại. Báo cáo các tuần trước xem ở tab Báo cáo.",
  runJob: "Chạy job cho {{week}}",
  runMissingAsk: "Còn thiếu {{n}} file. Vẫn chạy?",
  runningBy: "{{by}} bắt đầu lúc {{when}}.",
  result_ok: "Tất cả các bước đã chạy",
  result_partial: "Một số bước bị lỗi",
  result_error: "Job bị lỗi",
  result_running: "Đang chạy",
  runOf: "Lần chạy #{{n}} · {{week}} · {{by}} · {{when}}",
  took: "{{s}} giây",
  step_sap: "Tồn kho SAP",
  step_tpl: "Tồn kho 3PL",
  step_eusu: "Tồn kho EUSU",
  step_exf: "Tình trạng EXF",
  step_ar: "Công nợ phải thu",
  stepOk: "Xong",
  stepNotRun: "Chưa chạy",
  warnings: "{{n}} cảnh báo từ job",
  goReport: "Output đã cập nhật — mở bước 3 để xem báo cáo.",
  liveLog: "Log của job (trực tiếp)",
  fullLog: "Log của job",
  starting: "Đang bắt đầu…",
  history: "Các lần chạy",
  noRuns: "Chưa có lần chạy nào từ màn hình này.",
  colWeek: "Tuần",
  colStarted: "Bắt đầu",
  colBy: "Người chạy",
  colResult: "Kết quả",
  colSteps: "Bước",
  askedCodes: "cần mã hàng",
  viewLog: "Xem",
  codesTitle: "Job cần {{n}} mã hàng trong 00_Config.xlsx",
  codesHint: "Mã hàng mới chưa có category và giá mua. Điền ở đây (lưu thẳng vào 00_Config.xlsx, sheet 03_PD-Category-Price), rồi chạy lại job.",
  codesNone: "Mọi mã hàng trong 00_Config.xlsx đã có category và giá.",
  codesSave: "Lưu {{n}} mã hàng",
  codesSaved: "Đã lưu {{n}} mã hàng vào 00_Config.xlsx. Hãy chạy lại job.",
  colItem: "Mã hàng",
  colProduct: "Sản phẩm",
  colCategory: "Category",
  colPrice: "Giá mua (USD)",
  reportWeek: "Tuần báo cáo",
  vsWeek: "so với {{week}}",
  outputAt: "output cập nhật {{when}}",
  excelReportHint: "Báo cáo Excel — vẫn refresh từ output trong Excel.",
  chartsPpt: "Slide (PowerPoint)",
  chartsPptHint: "3 slide của Allie (EXF, công nợ, tồn kho) với số tuần này — tạo ngay từ 01_Output, không cần ổ Z:. Copy biểu đồ và bảng vào báo cáo tuần; phần nhận xét thì tự thêm.",
  noData: "Không có số liệu cho tuần này.",
  weekEmpty: "Output chưa có dữ liệu cho {{week}} — hãy chạy job trước.",
  lastWeek: "Tuần trước",
  thisWeek: "Tuần này",
  change: "Thay đổi",
  total: "Tổng",
  lab_id: "Kho",
  lab_category: "Category",
  lab_entity: "Entity",
  m_reserved: "Tồn đã giữ",
  m_uncommitted: "Tồn chưa phân bổ",
  m_reservedQty: "SL đã giữ",
  m_uncommittedQty: "SL chưa phân bổ",
  m_reservedAmt: "Giá trị đã giữ",
  m_uncommittedAmt: "Giá trị chưa phân bổ",
  m_inProduction: "Đang sản xuất",
  m_exFactory: "Đã xuất xưởng",
  m_paid: "Đã thanh toán",
  m_onTrack: "Đúng hạn",
  m_overdue: "Quá hạn",
  sec_sap: "Tình trạng tồn kho SAP",
  sec_tpl: "Tình trạng tồn kho 3PL",
  sec_eusu: "Tình trạng tồn kho EUSU",
  sec_exf: "Tình trạng EXF",
  sec_newOrder: "Tình trạng đơn hàng mới",
  sec_ar: "Quản lý công nợ phải thu",
  sec_stock: "Tình trạng tồn kho (3PL + EUSU)",
  noNewOrder: "Job New Order chưa chạy cho tuần này (lần gần nhất: {{week}}).",
  unit: "Đơn vị",
  no_chair: "Chair",
  no_cot: "Cot",
  no_table: "Table",
  no_tent: "Tent",
  no_others: "Others",
  arOverdue: "Khoản quá hạn ({{n}})",
  arAll: "Tất cả các khoản ({{n}})",
  arShowAll: "Xem tất cả",
  arShowOverdue: "Chỉ quá hạn",
  arNone: "Tuần này không có khoản quá hạn.",
  buyer: "Khách hàng",
  amount: "Số tiền",
  payDate: "Ngày thanh toán / dự kiến",
  trendTitle: "Tồn kho 3PL + EUSU năm nay, theo tuần (số lượng)",
};

const zh = {
  chExf: "EXF 状态 (USD)",
  chAr: "应收账款",
  chResQty: "预留库存数量 (pcs)",
  chResAmt: "预留库存金额 (USD)",
  chUncQty: "未分配库存数量 (pcs)",
  chUncAmt: "未分配库存金额 (USD)",
  excelReportHint2: "Excel 报告 — 在 Excel 中打开时会自动从 01_Output 刷新（需要 Z: 盘）。",
  upButton: "上传修改后的文件",
  upButtonHint: "下载 00_Config.xlsx，在 Excel 中修改后在此上传 — 保存前会先显示将要更改的内容。",
  upTitle: "已上传：{{file}}",
  upHint: "按 Item Code / Buyer / Stock Location ID 与当前文件比较。按“应用”之前不会保存；当前文件会备份。",
  upCounts: "修改 {{c}} · 新增 {{a}} · 文件中没有 {{m}}",
  upChanged: "修改",
  upAdded: "新增",
  upNotInFile: "文件中没有 — 保留",
  upRemoved: "将删除",
  upRemoveMissing: "同时删除我的文件中没有的 {{n}} 行（如果文件是在上次运行前下载的，请不要勾选）",
  upApply: "应用 {{n}} 项修改",
  upApplying: "应用中…",
  upNothing: "您的文件与当前文件相同 — 没有需要修改的内容。",
  upProblems: "文件中有 {{n}} 个问题 — 请在 Excel 中修正后重新上传。未保存任何内容。",
  upMore: "…另有 {{n}} 个。",
  upDone: "已按您的文件保存 — {{what}}。修改前的文件保存为 {{backup}}。",
  tabConfig: "配置",
  cfgFile: "00_Config.xlsx · 保存于 {{when}}",
  cfgHint: "作业每次运行都会读取的对照表。出现新物料代码、新买家或新库位时在此修改，下次运行即生效。",
  cfg_item: "物料",
  cfg_customer: "客户",
  cfg_location: "库位",
  cfgUse_item: "03_PD-Category-Price — 3PL 和 EUSU 按 Item Code 计算库存金额。缺少类别或价格的代码会使作业停止。",
  cfgUse_customer: "01_Customer — AR 将每个买家归入 Helinox 法人（忽略大小写和空格匹配）；不在列表中的买家归入 Others。",
  cfgUse_location: "02_Stock-Location — SAP 库存状态按 ID 命名库位。",
  cfgSearch: "在此表中搜索",
  cfgNeed: "缺少类别或价格 ({{n}})",
  cfgClear: "清除筛选",
  cfgCount: "{{total}} 行中的 {{n}} 行",
  cfgEdit: "编辑表格",
  cfgAdd: "添加一行",
  cfgCancel: "取消",
  cfgSave: "保存 ({{n}})",
  cfgSaveFirst: "请先保存或取消此表的修改。",
  cfgRunning: "作业正在运行，结束后再编辑。",
  cfgViewOnly: "您只能查看此表；修改需要 Sales Op. Python 的编辑权限。",
  cfgRow: "行",
  cfgRowHint: "Excel 表中的行号",
  cfgNew: "新",
  cfgRemove: "删除此行",
  cfgKeep: "保留此行",
  cfgWas: "原值：{{v}}",
  cfgMissing: "缺失",
  cfgDup: "重复",
  cfgDupHint: "此代码出现在多行（作业把无法匹配的代码另加一行）。请删除多余的行。",
  cfgNone: "没有匹配的行。",
  cfgSaved: "{{sheet}}：已保存 {{n}} 项修改。修改前的文件保存为 {{backup}}。",
  title: "Sales Op 周报",
  week: "周",
  thisWeekTag: "本周",
  sandbox: "测试环境 · 沙盒文件夹",
  sandboxHint: "在测试环境中，作业运行于文件夹的副本，绝不触碰团队在 Z:\\AutoJobs 的真实文件。",
  refresh: "刷新",
  loading: "加载中…",
  tabFiles: "文件",
  tabRun: "运行",
  tabReport: "报告",
  notRun: "未运行",
  running: "运行中…",
  dropTitle: "将 {{week}} 的文件拖到这里",
  dropHint: "一次全部拖入 — 每个文件按名称归入对应行，并以作业读取的名称保存。",
  chooseFiles: "选择文件",
  uploading: "上传中…",
  savedAs: "已保存为 {{file}}。",
  dismiss: "关闭",
  filesCount: "{{week}}：{{total}} 个文件中已有 {{n}} 个",
  colFile: "文件",
  colStatus: "状态",
  colSaved: "保存为",
  colSize: "大小",
  colUploaded: "上传",
  colAction: "操作",
  group_sap: "SAP 库存",
  group_eusu: "EUSU 库存",
  group_exf: "待交订单及出货状态 (EXF)",
  group_ar: "应收账款",
  missing: "缺少",
  ready: "就绪",
  otherWeek: "名称为 {{tag}}",
  tagHint: "作业读取本周或上周（沿用）的文件，其他周的文件会被跳过。",
  twoFiles: "{{n}} 个文件",
  twoHint: "此行匹配到多个文件，作业可能读错。请删除多余的文件。",
  originalName: "上传时名为 {{name}}",
  fromFolder: "直接放入文件夹",
  fromFolderHint: "该文件直接放入文件夹（Z: 盘），而非通过本页面。",
  upload: "上传",
  replace: "替换",
  remove: "删除",
  removeAsk: "从周文件夹中删除 {{name}}？文件将保存在 _portal_replaced 中。",
  extrasTitle: "文件夹中的其他文件",
  extrasHint: "不属于作业所需的 16 个文件。请删除无关文件 — 多余的 SAP-Inventory 文件也会被作业读取。",
  allFiles: "{{n}} 个文件已齐",
  someMissing: "{{total}} 个文件中缺少 {{n}} 个 — 需要它们的步骤会失败",
  onlyCurrent: "仅可运行 {{week}}",
  onlyCurrentHint: "作业根据今天的日期确定周次，因此只能运行当前周。之前各周的报告在“报告”标签中。",
  runJob: "运行 {{week}} 的作业",
  runMissingAsk: "缺少 {{n}} 个文件。仍要运行吗？",
  runningBy: "由 {{by}} 于 {{when}} 启动。",
  result_ok: "所有步骤已完成",
  result_partial: "部分步骤失败",
  result_error: "作业失败",
  result_running: "运行中",
  runOf: "第 {{n}} 次运行 · {{week}} · {{by}} · {{when}}",
  took: "{{s}} 秒",
  step_sap: "SAP 库存",
  step_tpl: "3PL 库存",
  step_eusu: "EUSU 库存",
  step_exf: "EXF 状态",
  step_ar: "应收账款",
  stepOk: "完成",
  stepNotRun: "未运行",
  warnings: "作业警告 {{n}} 条",
  goReport: "结果已更新 — 打开第 3 步查看报告。",
  liveLog: "作业日志（实时）",
  fullLog: "作业日志",
  starting: "启动中…",
  history: "运行记录",
  noRuns: "尚无从本页面运行的记录。",
  colWeek: "周",
  colStarted: "开始",
  colBy: "运行人",
  colResult: "结果",
  colSteps: "步骤",
  askedCodes: "需要物料代码",
  viewLog: "查看",
  codesTitle: "作业需要 00_Config.xlsx 中的 {{n}} 个物料代码",
  codesHint: "新物料代码尚无类别和采购价。在此填写（直接保存到 00_Config.xlsx 的 03_PD-Category-Price 工作表），然后重新运行作业。",
  codesNone: "00_Config.xlsx 中所有物料代码均已有类别和价格。",
  codesSave: "保存 {{n}} 个物料代码",
  codesSaved: "已将 {{n}} 个物料代码保存到 00_Config.xlsx。请重新运行作业。",
  colItem: "物料代码",
  colProduct: "产品",
  colCategory: "类别",
  colPrice: "采购价 (USD)",
  reportWeek: "报告周",
  vsWeek: "对比 {{week}}",
  outputAt: "结果更新于 {{when}}",
  excelReportHint: "Excel 报告 — 仍在 Excel 中从结果文件刷新。",
  chartsPpt: "幻灯片 (PowerPoint)",
  chartsPptHint: "Allie 的三张幻灯片（EXF、应收账款、库存）填入本周数据——由 01_Output 即时生成，无需 Z: 盘。将图表和表格复制到周报中，评论请手动补充。",
  noData: "本周没有数据。",
  weekEmpty: "结果文件中还没有 {{week}} 的数据 — 请先运行作业。",
  lastWeek: "上周",
  thisWeek: "本周",
  change: "变化",
  total: "合计",
  lab_id: "库位",
  lab_category: "类别",
  lab_entity: "法人",
  m_reserved: "预留库存",
  m_uncommitted: "未分配库存",
  m_reservedQty: "预留数量",
  m_uncommittedQty: "未分配数量",
  m_reservedAmt: "预留金额",
  m_uncommittedAmt: "未分配金额",
  m_inProduction: "生产中",
  m_exFactory: "已出厂",
  m_paid: "已付款",
  m_onTrack: "正常",
  m_overdue: "逾期",
  sec_sap: "SAP 库存状态",
  sec_tpl: "3PL 库存状态",
  sec_eusu: "EUSU 库存状态",
  sec_exf: "EXF 状态",
  sec_newOrder: "新订单状态",
  sec_ar: "应收账款管理",
  sec_stock: "库存状态 (3PL + EUSU)",
  noNewOrder: "本周未运行新订单作业（最近一次：{{week}}）。",
  unit: "单位",
  no_chair: "Chair",
  no_cot: "Cot",
  no_table: "Table",
  no_tent: "Tent",
  no_others: "Others",
  arOverdue: "逾期款项（{{n}}）",
  arAll: "全部款项（{{n}}）",
  arShowAll: "显示全部",
  arShowOverdue: "仅逾期",
  arNone: "本周没有逾期款项。",
  buyer: "客户",
  amount: "金额",
  payDate: "付款 / 计划日期",
  trendTitle: "今年 3PL + EUSU 库存，按周（数量）",
};

// French and Japanese (task #1173, 2026-11-04) — generated from `en`; a string not yet translated reads English.
const fr = {
  "chExf": "Statut EXF (USD)",
  "chAr": "Créances clients",
  "chResQty": "Quantité de stock réservé (pcs)",
  "chResAmt": "Montant du stock réservé (USD)",
  "chUncQty": "Quantité de stock non engagé (pcs)",
  "chUncAmt": "Montant du stock non engagé (USD)",
  "excelReportHint2": "Le rapport Excel — il s'actualise tout seul depuis 01_Output à l'ouverture dans Excel (nécessite le lecteur Z:).",
  "upButton": "Importer le fichier modifié",
  "upButtonHint": "Téléchargez 00_Config.xlsx, modifiez-le dans Excel, puis importez-le ici — vous voyez ce qui change avant tout enregistrement.",
  "upTitle": "Importé : {{file}}",
  "upHint": "Comparé au fichier actuel par Item Code / Buyer / Stock Location ID. Rien n'est enregistré tant que vous n'avez pas cliqué sur Appliquer ; le fichier actuel est conservé en sauvegarde.",
  "upCounts": "{{c}} modifiées · {{a}} ajoutées · {{m}} absentes de votre fichier",
  "upChanged": "Modifiée",
  "upAdded": "Nouvelle",
  "upNotInFile": "Absente de votre fichier — conservée",
  "upRemoved": "Sera supprimée",
  "upRemoveMissing": "Supprimer aussi les {{n}} ligne(s) absentes de mon fichier (laissez décoché si votre copie a été téléchargée avant la dernière exécution)",
  "upApply": "Appliquer {{n}} modification(s)",
  "upApplying": "Application…",
  "upNothing": "Votre fichier est identique au fichier actuel — rien à modifier.",
  "upProblems": "{{n}} problème(s) dans le fichier — corrigez-les dans Excel et importez de nouveau. Rien n'a été enregistré.",
  "upMore": "…et {{n}} de plus.",
  "upDone": "Enregistré à partir de votre fichier — {{what}}. Le fichier précédent est conservé sous {{backup}}.",
  "tabConfig": "Configuration",
  "cfgFile": "00_Config.xlsx · enregistré {{when}}",
  "cfgHint": "Les tables de correspondance lues par le job à chaque exécution. Modifiez-les ici lorsqu'un nouvel élément apparaît — un nouvel item code, un nouveau buyer, un nouvel emplacement de stock — et la prochaine exécution les utilisera.",
  "cfg_item": "Articles",
  "cfg_customer": "Clients",
  "cfg_location": "Emplacements de stock",
  "cfgUse_item": "03_PD-Category-Price — 3PL et EUSU valorisent leur stock par Item Code. Un code sans catégorie ni prix interrompt l'exécution.",
  "cfgUse_customer": "01_Customer — AR classe chaque buyer sous son entité Helinox (comparaison sans tenir compte des majuscules ni des espaces) ; un buyer absent de la liste va dans Others.",
  "cfgUse_location": "02_Stock-Location — SAP Stock Status nomme chaque emplacement par son ID.",
  "cfgSearch": "Rechercher dans cette feuille",
  "cfgNeed": "Sans catégorie ni prix ({{n}})",
  "cfgClear": "Effacer les filtres",
  "cfgCount": "{{n}} sur {{total}} lignes",
  "cfgEdit": "Modifier le tableau",
  "cfgAdd": "Ajouter une ligne",
  "cfgCancel": "Annuler",
  "cfgSave": "Enregistrer ({{n}})",
  "cfgSaveFirst": "Enregistrez ou annulez d'abord les modifications de cette feuille.",
  "cfgRunning": "Le job est en cours — modifiez une fois qu'il est terminé.",
  "cfgViewOnly": "Vous pouvez lire cette feuille ; la modifier nécessite un accès en édition à Sales Op. Python.",
  "cfgRow": "Ligne",
  "cfgRowHint": "La ligne dans la feuille Excel",
  "cfgNew": "Nouvelle",
  "cfgRemove": "Supprimer cette ligne",
  "cfgKeep": "Conserver cette ligne",
  "cfgWas": "Avant : {{v}}",
  "cfgMissing": "manquant",
  "cfgDup": "en double",
  "cfgDupHint": "Ce code figure sur plusieurs lignes (le job ajoute un code qu'il ne peut pas rapprocher comme seconde ligne). Supprimez la ligne en trop.",
  "cfgNone": "Aucune ligne ne correspond.",
  "cfgSaved": "{{sheet}} : {{n}} modification(s) enregistrée(s). Le fichier précédent est conservé sous {{backup}}.",
  "title": "Rapport hebdomadaire Sales Op",
  "week": "Semaine",
  "thisWeekTag": "cette semaine",
  "sandbox": "Staging · dossier bac à sable",
  "sandboxHint": "Sur staging, le job s'exécute sur une copie du dossier, jamais sur les vrais fichiers Z:\\AutoJobs de l'équipe.",
  "refresh": "Actualiser",
  "loading": "Chargement…",
  "tabFiles": "Fichiers",
  "tabRun": "Exécution",
  "tabReport": "Rapport",
  "notRun": "non exécuté",
  "running": "En cours…",
  "dropTitle": "Déposez ici les fichiers de {{week}}",
  "dropHint": "Tous à la fois — chacun va sur sa ligne d'après son nom et est enregistré sous le nom que le job lit.",
  "chooseFiles": "Choisir des fichiers",
  "uploading": "Importation…",
  "savedAs": "Enregistré sous {{file}}.",
  "dismiss": "Fermer",
  "filesCount": "{{n}} fichiers sur {{total}} dans {{week}}",
  "colFile": "Fichier",
  "colStatus": "Statut",
  "colSaved": "Enregistré sous",
  "colSize": "Taille",
  "colUploaded": "Importé le",
  "colAction": "Action",
  "group_sap": "Stock SAP",
  "group_eusu": "Stock EUSU",
  "group_exf": "Statut des commandes en attente et des expéditions (EXF)",
  "group_ar": "Créances clients",
  "missing": "Manquant",
  "ready": "Prêt",
  "otherWeek": "Nommé {{tag}}",
  "tagHint": "Le job lit le fichier de cette semaine ou celui de la semaine dernière (en report). Toute autre semaine est ignorée.",
  "twoFiles": "{{n}} fichiers",
  "twoHint": "Plus d'un fichier correspond à cette ligne ; le job risque de lire le mauvais. Supprimez le fichier en trop.",
  "originalName": "importé sous le nom {{name}}",
  "fromFolder": "depuis le dossier",
  "fromFolderHint": "Placé directement dans le dossier (lecteur Z:), et non via cet écran.",
  "upload": "Importer",
  "replace": "Remplacer",
  "remove": "Supprimer",
  "removeAsk": "Supprimer {{name}} du dossier de la semaine ? Il est conservé dans _portal_replaced.",
  "extrasTitle": "Autres fichiers du dossier",
  "extrasHint": "Ne fait pas partie des 16 fichiers attendus par le job. Supprimez tout ce qui n'a pas sa place — un fichier SAP-Inventory en trop est lu par le job.",
  "allFiles": "Les {{n}} fichiers sont présents",
  "someMissing": "{{n}} fichiers sur {{total}} manquants — les étapes qui en ont besoin échoueront",
  "onlyCurrent": "S'exécute uniquement pour {{week}}",
  "onlyCurrentHint": "Le job détermine sa semaine à partir de la date du jour ; il ne peut donc s'exécuter que pour la semaine en cours. Les rapports des semaines précédentes sont dans l'onglet Rapport.",
  "runJob": "Lancer le job pour {{week}}",
  "runMissingAsk": "{{n}} fichier(s) manquant(s). Lancer quand même ?",
  "runningBy": "Lancé par {{by}} à {{when}}.",
  "result_ok": "Toutes les étapes ont été exécutées",
  "result_partial": "Certaines étapes ont échoué",
  "result_error": "Le job a échoué",
  "result_running": "En cours",
  "runOf": "Exécution n° {{n}} · {{week}} · {{by}} · {{when}}",
  "took": "{{s}} s",
  "step_sap": "Stock SAP",
  "step_tpl": "Stock 3PL",
  "step_eusu": "Stock EUSU",
  "step_exf": "Statut EXF",
  "step_ar": "Créances clients",
  "stepOk": "Terminé",
  "stepNotRun": "Non exécuté",
  "warnings": "{{n}} avertissement(s) du job",
  "goReport": "La sortie est à jour — ouvrez l'étape 3 pour le rapport.",
  "liveLog": "Journal du job (en direct)",
  "fullLog": "Journal du job",
  "starting": "Démarrage…",
  "history": "Exécutions",
  "noRuns": "Aucune exécution depuis cet écran pour l'instant.",
  "colWeek": "Semaine",
  "colStarted": "Début",
  "colBy": "Par",
  "colResult": "Résultat",
  "colSteps": "Étapes",
  "askedCodes": "a demandé des item codes",
  "viewLog": "Afficher",
  "codesTitle": "Le job a besoin de {{n}} item code(s) dans 00_Config.xlsx",
  "codesHint": "Les nouveaux item codes n'ont pas encore de catégorie ni de prix d'achat. Renseignez-les ici (enregistrés directement dans 00_Config.xlsx, feuille 03_PD-Category-Price), puis relancez le job.",
  "codesNone": "Chaque item code de 00_Config.xlsx a une catégorie et un prix.",
  "codesSave": "Enregistrer {{n}} item code(s)",
  "codesSaved": "{{n}} item code(s) enregistré(s) dans 00_Config.xlsx. Relancez le job.",
  "colItem": "Code article",
  "colProduct": "Produit",
  "colCategory": "Catégorie",
  "colPrice": "Prix d'achat (USD)",
  "reportWeek": "Semaine du rapport",
  "vsWeek": "par rapport à {{week}}",
  "outputAt": "sortie mise à jour {{when}}",
  "excelReportHint": "Le rapport Excel — il s'actualise toujours depuis la sortie dans Excel.",
  "chartsPpt": "Diapositives (PowerPoint)",
  "chartsPptHint": "Les trois diapositives d'Allie (EXF, créances clients, stock) avec les chiffres de cette semaine — générées maintenant depuis 01_Output, sans lecteur Z:. Copiez les graphiques et tableaux dans la présentation hebdomadaire ; ajoutez les commentaires à la main.",
  "noData": "Aucun chiffre pour cette semaine.",
  "weekEmpty": "La sortie ne contient encore rien pour {{week}} — lancez d'abord le job.",
  "lastWeek": "Semaine dernière",
  "thisWeek": "Cette semaine",
  "change": "Variation",
  "total": "Total",
  "lab_id": "Emplacement de stock",
  "lab_category": "Catégorie",
  "lab_entity": "Entité",
  "m_reserved": "Stock réservé",
  "m_uncommitted": "Stock non engagé",
  "m_reservedQty": "Qté réservée",
  "m_uncommittedQty": "Qté non engagée",
  "m_reservedAmt": "Montant réservé",
  "m_uncommittedAmt": "Montant non engagé",
  "m_inProduction": "En production",
  "m_exFactory": "Sortie usine",
  "m_paid": "Payé",
  "m_onTrack": "Dans les temps",
  "m_overdue": "En retard",
  "sec_sap": "SAP Stock Status",
  "sec_tpl": "3PL Stock Status",
  "sec_eusu": "EUSU Stock Status",
  "sec_exf": "EXF Status",
  "sec_newOrder": "New Order Status",
  "sec_ar": "Account Receivable Management",
  "sec_stock": "Stock Status (3PL + EUSU)",
  "noNewOrder": "Le job New Order ne s'est pas exécuté cette semaine (dernier : {{week}}).",
  "unit": "Unité",
  "no_chair": "Chair",
  "no_cot": "Cot",
  "no_table": "Table",
  "no_tent": "Tent",
  "no_others": "Others",
  "arOverdue": "Paiements en retard ({{n}})",
  "arAll": "Toutes les lignes de paiement ({{n}})",
  "arShowAll": "Afficher toutes les lignes",
  "arShowOverdue": "En retard uniquement",
  "arNone": "Aucun paiement en retard cette semaine.",
  "buyer": "Acheteur",
  "amount": "Montant",
  "payDate": "Date de paiement / prévue",
  "trendTitle": "Stock 3PL + EUSU cette année, par semaine (qté)"
};
const ja = {
  "chExf": "EXFステータス (USD)",
  "chAr": "売掛金",
  "chResQty": "引当済み在庫数量 (pcs)",
  "chResAmt": "引当済み在庫金額 (USD)",
  "chUncQty": "未引当在庫数量 (pcs)",
  "chUncAmt": "未引当在庫金額 (USD)",
  "excelReportHint2": "Excelレポート — Excelで開くと 01_Output から自動的に更新されます（Z:ドライブが必要）。",
  "upButton": "編集したファイルをアップロード",
  "upButtonHint": "00_Config.xlsx をダウンロードし、Excelで編集してからここにアップロードしてください — 保存する前に変更内容を確認できます。",
  "upTitle": "アップロード済み：{{file}}",
  "upHint": "Item Code / Buyer / Stock Location ID で現在のファイルと比較します。適用を押すまで何も保存されません。現在のファイルはバックアップとして保持されます。",
  "upCounts": "変更 {{c}} 件 · 追加 {{a}} 件 · ファイルにないもの {{m}} 件",
  "upChanged": "変更",
  "upAdded": "新規",
  "upNotInFile": "ファイルにはありません — 保持",
  "upRemoved": "削除されます",
  "upRemoveMissing": "ファイルにない {{n}} 行も削除する（最後の実行より前にダウンロードしたコピーの場合はオフのままにしてください）",
  "upApply": "{{n}} 件の変更を適用",
  "upApplying": "適用中…",
  "upNothing": "ファイルは現在のものと同じです — 変更はありません。",
  "upProblems": "ファイルに {{n}} 件の問題があります — Excelで修正して再度アップロードしてください。何も保存されていません。",
  "upMore": "…ほか {{n}} 件。",
  "upDone": "ファイルから保存しました — {{what}}。変更前のファイルは {{backup}} として保持されています。",
  "tabConfig": "設定",
  "cfgFile": "00_Config.xlsx · 保存 {{when}}",
  "cfgHint": "ジョブが毎回の実行で読み込む参照表です。新しいitem code、新しいbuyer、新しい在庫ロケーションなど新しいものが出てきたらここで変更すると、次回の実行から反映されます。",
  "cfg_item": "アイテム",
  "cfg_customer": "顧客",
  "cfg_location": "在庫ロケーション",
  "cfgUse_item": "03_PD-Category-Price — 3PLとEUSUはItem Codeで在庫を評価します。カテゴリまたは価格のないコードがあると実行が止まります。",
  "cfgUse_customer": "01_Customer — ARは各buyerをHelinoxのエンティティに振り分けます（大文字・小文字とスペースを無視して照合）。一覧にないbuyerはOthersになります。",
  "cfgUse_location": "02_Stock-Location — SAP Stock Statusは各ロケーションをIDで呼びます。",
  "cfgSearch": "このシートを検索",
  "cfgNeed": "カテゴリまたは価格なし ({{n}})",
  "cfgClear": "フィルターをクリア",
  "cfgCount": "{{total}} 行中 {{n}} 行",
  "cfgEdit": "表を編集",
  "cfgAdd": "行を追加",
  "cfgCancel": "キャンセル",
  "cfgSave": "保存 ({{n}})",
  "cfgSaveFirst": "先にこのシートの変更を保存するか、キャンセルしてください。",
  "cfgRunning": "ジョブを実行中です — 完了してから編集してください。",
  "cfgViewOnly": "このシートは閲覧できます。変更するには Sales Op. Python の編集権限が必要です。",
  "cfgRow": "行",
  "cfgRowHint": "Excelシート上の行",
  "cfgNew": "新規",
  "cfgRemove": "この行を削除",
  "cfgKeep": "この行を残す",
  "cfgWas": "変更前：{{v}}",
  "cfgMissing": "未入力",
  "cfgDup": "重複",
  "cfgDupHint": "このコードが複数の行にあります（ジョブは照合できないコードを2行目として追加します）。余分な行を削除してください。",
  "cfgNone": "一致する行はありません。",
  "cfgSaved": "{{sheet}}：{{n}} 件の変更を保存しました。変更前のファイルは {{backup}} として保持されています。",
  "title": "Sales Op 週次レポート",
  "week": "週",
  "thisWeekTag": "今週",
  "sandbox": "Staging · サンドボックスフォルダ",
  "sandboxHint": "Stagingではジョブはフォルダのコピー上で実行され、チームの実際の Z:\\AutoJobs のファイルには触れません。",
  "refresh": "更新",
  "loading": "読み込み中…",
  "tabFiles": "ファイル",
  "tabRun": "実行",
  "tabReport": "レポート",
  "notRun": "未実行",
  "running": "実行中…",
  "dropTitle": "{{week}} のファイルをここにドロップ",
  "dropHint": "まとめて一度に — 各ファイルは名前に従って該当の行に入り、ジョブが読み込む名前で保存されます。",
  "chooseFiles": "ファイルを選択",
  "uploading": "アップロード中…",
  "savedAs": "{{file}} として保存しました。",
  "dismiss": "閉じる",
  "filesCount": "{{week}} のファイル {{total}} 件中 {{n}} 件",
  "colFile": "ファイル",
  "colStatus": "ステータス",
  "colSaved": "保存名",
  "colSize": "サイズ",
  "colUploaded": "アップロード日時",
  "colAction": "操作",
  "group_sap": "SAP在庫",
  "group_eusu": "EUSU在庫",
  "group_exf": "未出荷注文と出荷状況 (EXF)",
  "group_ar": "売掛金",
  "missing": "不足",
  "ready": "準備完了",
  "otherWeek": "{{tag}} と名付けられています",
  "tagHint": "ジョブは今週のファイル、または前週のファイル（繰り越し）を読み込みます。それ以外の週はスキップされます。",
  "twoFiles": "{{n}} ファイル",
  "twoHint": "この行に一致するファイルが複数あり、ジョブが誤ったものを読み込む可能性があります。余分なファイルを削除してください。",
  "originalName": "{{name}} としてアップロード",
  "fromFolder": "フォルダから",
  "fromFolderHint": "この画面ではなく、フォルダ（Z:ドライブ）に直接置かれたファイルです。",
  "upload": "アップロード",
  "replace": "置き換え",
  "remove": "削除",
  "removeAsk": "{{name}} を週フォルダから削除しますか？ _portal_replaced に保管されます。",
  "extrasTitle": "フォルダ内のその他のファイル",
  "extrasHint": "ジョブが想定する16ファイルに含まれていません。不要なものは削除してください — 余分な SAP-Inventory ファイルはジョブに読み込まれます。",
  "allFiles": "{{n}} ファイルすべて揃っています",
  "someMissing": "{{total}} ファイル中 {{n}} ファイルが不足しています — それを必要とするステップは失敗します",
  "onlyCurrent": "{{week}} のみ実行できます",
  "onlyCurrentHint": "ジョブは今日の日付から対象週を判断するため、今週分しか実行できません。過去の週のレポートは「レポート」タブにあります。",
  "runJob": "{{week}} のジョブを実行",
  "runMissingAsk": "{{n}} 件のファイルが不足しています。それでも実行しますか？",
  "runningBy": "{{by}} が {{when}} に開始しました。",
  "result_ok": "すべてのステップを実行しました",
  "result_partial": "一部のステップが失敗しました",
  "result_error": "ジョブが失敗しました",
  "result_running": "実行中",
  "runOf": "実行 #{{n}} · {{week}} · {{by}} · {{when}}",
  "took": "{{s}} 秒",
  "step_sap": "SAP在庫",
  "step_tpl": "3PL在庫",
  "step_eusu": "EUSU在庫",
  "step_exf": "EXFステータス",
  "step_ar": "売掛金",
  "stepOk": "完了",
  "stepNotRun": "未実行",
  "warnings": "ジョブからの警告 {{n}} 件",
  "goReport": "出力が更新されました — レポートはステップ3を開いてください。",
  "liveLog": "ジョブログ（ライブ）",
  "fullLog": "ジョブログ",
  "starting": "開始中…",
  "history": "実行履歴",
  "noRuns": "この画面からの実行はまだありません。",
  "colWeek": "週",
  "colStarted": "開始",
  "colBy": "実行者",
  "colResult": "結果",
  "colSteps": "ステップ",
  "askedCodes": "item code の入力を要求",
  "viewLog": "表示",
  "codesTitle": "ジョブには 00_Config.xlsx に item code が {{n}} 件必要です",
  "codesHint": "新しい item code にはまだカテゴリと仕入価格がありません。ここで入力してください（00_Config.xlsx のシート 03_PD-Category-Price に直接保存されます）。その後、ジョブをもう一度実行してください。",
  "codesNone": "00_Config.xlsx のすべての item code にカテゴリと価格があります。",
  "codesSave": "item code {{n}} 件を保存",
  "codesSaved": "item code {{n}} 件を 00_Config.xlsx に保存しました。ジョブをもう一度実行してください。",
  "colItem": "品目コード",
  "colProduct": "製品",
  "colCategory": "カテゴリ",
  "colPrice": "仕入価格 (USD)",
  "reportWeek": "レポート対象週",
  "vsWeek": "{{week}} との比較",
  "outputAt": "出力の更新 {{when}}",
  "excelReportHint": "Excelレポート — Excel上で引き続き出力から更新されます。",
  "chartsPpt": "スライド (PowerPoint)",
  "chartsPptHint": "Allieの3枚のスライド（EXF、売掛金、在庫）に今週の数値を反映したものです — 01_Output からその場で作成され、Z:ドライブは不要です。グラフと表を週次の資料にコピーし、コメントは手作業で追加してください。",
  "noData": "今週の数値はありません。",
  "weekEmpty": "{{week}} の出力にはまだ何も入っていません — 先にジョブを実行してください。",
  "lastWeek": "前週",
  "thisWeek": "今週",
  "change": "増減",
  "total": "合計",
  "lab_id": "在庫ロケーション",
  "lab_category": "カテゴリ",
  "lab_entity": "エンティティ",
  "m_reserved": "引当済み在庫",
  "m_uncommitted": "未引当在庫",
  "m_reservedQty": "引当済み数量",
  "m_uncommittedQty": "未引当数量",
  "m_reservedAmt": "引当済み金額",
  "m_uncommittedAmt": "未引当金額",
  "m_inProduction": "生産中",
  "m_exFactory": "工場出荷",
  "m_paid": "支払済み",
  "m_onTrack": "順調",
  "m_overdue": "期限超過",
  "sec_sap": "SAP在庫状況",
  "sec_tpl": "3PL在庫状況",
  "sec_eusu": "EUSU在庫状況",
  "sec_exf": "EXFステータス",
  "sec_newOrder": "新規注文状況",
  "sec_ar": "売掛金管理",
  "sec_stock": "在庫状況 (3PL + EUSU)",
  "noNewOrder": "New Order ジョブは今週まだ実行されていません（前回：{{week}}）。",
  "unit": "単位",
  "no_chair": "Chair",
  "no_cot": "Cot",
  "no_table": "Table",
  "no_tent": "Tent",
  "no_others": "Others",
  "arOverdue": "支払期限超過 ({{n}})",
  "arAll": "すべての支払明細 ({{n}})",
  "arShowAll": "すべての明細を表示",
  "arShowOverdue": "期限超過のみ",
  "arNone": "今週は支払期限超過のものはありません。",
  "buyer": "バイヤー",
  "amount": "金額",
  "payDate": "支払日 / 予定日",
  "trendTitle": "今年の3PL + EUSU在庫（週別、数量）"
};

const dictionary = { ns: 'xSopw', en, ko, vi, zh, fr, ja };
export default dictionary;
